import { Attachment } from '../../../shared-components/models/attachment.model';
import * as moment from 'moment';

export class CommunicationLog {

    // Server Properties
    Id: number;
    StudentId: number;
    StaffId: number;
    StudentNumber: string;
    NickName: string;
    FirstName: string;
    MiddleName: string;
    LastName: string;
    StaffName: string;
    Site: string;
    Year: string;
    Date: Date;
    Time: string | Date;    // I'm not sure why this is a datetime, but it is on the API
    TypeId: string;
    ContactPersonId: string;
    Notes: string;
    ResultId: string;
    Attach: string;
    Location: string;
    Duration: number;
    Comments: string;
    RequestedBy: string;
    RequestedByName: string;
    Reaction: string;
    NotifyCounselor: boolean;
    NotifyParent: boolean;
    NotifyStudent: boolean;
    NotifyTeacher: boolean;
    AddedOn: Date;
    LastUpdatedBy: string;
    LastUpdatedOn: Date;
    MassEmailLogId: number;
    isSelected: boolean;
    AttachmentRecords: Attachment[];
    Reason: string | string[] = [];
    ReasonIds: number[] = [];
    InformOthers: string | string[] = [];
    ConfidentialNote: string;
    Confidential: string;
    Subject: string;

    // Local Properties
    typeCode;
    personCode;
    resultCode;
    MoreAreaDataLoaded = false;

    // Methods
    get displayTime() {
        if (this.Time && this.Time instanceof Date) {
            return moment(this.Time).format('hh:mm a');
        } else {
            return <string>this.Time;
        }
    }
}
